/* eslint-disable camelcase */
export default {
  my_account: 'My account',
  position: 'Position: {0}',
  limit_hit: 'Not all nodes have been loaded because of the limit',
  load_more: 'Load more',
};
